import { intl } from 'tci18n-vue2'
import cookies from "js-cookie";
import "@toca/toca-wiki-template/dist/style.css";
import { TocaWikiLinkShareRangeSet } from "@toca/toca-wiki-template";

// 获取分享权限提示语
export function getShareAuthTip(auth, scope, spaceInfo, isNeedPrefix = true) {
  let shareScopeTitle = '';
  const shareScopeList = [intl.$t("仅文档协作者可通过链接访问#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1"), intl.$t("内获得链接的人仅查看#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1"), intl.$t("内获得链接的人可查看下载#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1"), intl.$t("内获得链接的人可编辑#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1"), intl.$t("互联网上获得链接的人仅查看#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1"), intl.$t("互联网上获得链接的人可查看下载#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1")];







  if (scope === 'PUBLIC' && auth === 'READ_DOWNLOAD') {
    shareScopeTitle = shareScopeList[5];
  } else if (scope === 'ORGANIZATION' && auth === 'READ') {
    shareScopeTitle = shareScopeList[1];
  } else if (scope === 'ORGANIZATION' && auth === 'READ_DOWNLOAD') {
    shareScopeTitle = shareScopeList[2];
  } else if (scope === 'ORGANIZATION' && auth === 'WRITE') {
    shareScopeTitle = shareScopeList[3];
  } else if (scope === 'COLLABORATOR') {
    shareScopeTitle = shareScopeList[0];
  } else if (scope === 'PUBLIC' && auth === 'READ') {
    shareScopeTitle = shareScopeList[4];
  }

  let index = shareScopeList.indexOf(shareScopeTitle);
  if ([1, 2, 3].includes(index)) {
    let spaceName = spaceInfo?.spaceName || intl.$t("同程旅行#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1");
    if (isNeedPrefix) {
      return intl.$t("分享设置：#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_1") + spaceName + shareScopeTitle;
    }
    return spaceName + shareScopeTitle;
  }
  if (isNeedPrefix) {
    return intl.$t("分享设置：#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_2") + shareScopeTitle;
  }
  return shareScopeTitle;
}

// 挂载头部链接分享范围组件
export function mountHeadLinkShareRangeSet(domId, isWiki, cloudI18n, fileId, canUpdateUrlAuth, onUpdateShareRange, onUpdateShareAuthTip, onLinkRangeSetDropdownVisible) {
  const cookie = {
    token: cookies.get("token"),
    spaceId: cookies.get("spaceId"),
    userId: cookies.get("userId"),
    deviceId: cookies.get("deviceId"),
    memberUniqueId: cookies.get("memberUniqueId"),
    memberId: cookies.get("memberId")
  };
  let env = process.env.VUE_APP_STATIC_NODE_ENV;
  return new TocaWikiLinkShareRangeSet(domId, {
    locale: cloudI18n,
    env: env,
    userInfo: cookie,
    onlyShowAuthDesc: true,
    fileId: fileId,
    isWiki: isWiki,
    canUpdateLinkShareRange: canUpdateUrlAuth,
    shareAuth: '',
    shareScope: '',
    shareExpireDate: null,
    sharePassword: '',
    spaceInfo: {
      spaceId: '0583d',
      spaceName: intl.$t("同程旅行#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_2")
    },
    onUpdateShareRange: onUpdateShareRange,
    onUpdateShareAuthTip: onUpdateShareAuthTip,
    onLinkRangeSetDropdownVisible: onLinkRangeSetDropdownVisible
  });
}

// 挂载权限管理链接分享范围组件
export function mountAuthManagerLinkShareRangeSet(domId, isWiki, cloudI18n, fileId, canUpdateUrlAuth, onUpdateShareRange, onUpdateShareAuthTip, onLinkRangeSetDropdownVisible) {
  const cookie = {
    token: cookies.get("token"),
    spaceId: cookies.get("spaceId"),
    userId: cookies.get("userId"),
    deviceId: cookies.get("deviceId"),
    memberUniqueId: cookies.get("memberUniqueId"),
    memberId: cookies.get("memberId")
  };
  let env = process.env.VUE_APP_STATIC_NODE_ENV;
  return new TocaWikiLinkShareRangeSet(domId, {
    locale: cloudI18n,
    env: env,
    userInfo: cookie,
    onlyShowAuthDesc: false,
    fileId: fileId,
    isWiki: isWiki,
    canUpdateLinkShareRange: canUpdateUrlAuth,
    shareAuth: '',
    shareScope: '',
    shareExpireDate: null,
    sharePassword: '',
    spaceInfo: {
      spaceId: '0583d',
      spaceName: intl.$t("同程旅行#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_3")
    },
    onUpdateShareRange: onUpdateShareRange,
    onUpdateShareAuthTip: onUpdateShareAuthTip,
    onLinkRangeSetDropdownVisible: onLinkRangeSetDropdownVisible
  });
}

// 挂载分享链接分享范围组件
export function mountShareLinkShareRangeSet(domId, isWiki, cloudI18n, fileId, canUpdateUrlAuth, onUpdateShareRange, onUpdateShareAuthTip, onLinkRangeSetDropdownVisible) {
  const cookie = {
    token: cookies.get("token"),
    spaceId: cookies.get("spaceId"),
    userId: cookies.get("userId"),
    deviceId: cookies.get("deviceId"),
    memberUniqueId: cookies.get("memberUniqueId"),
    memberId: cookies.get("memberId")
  };
  let env = process.env.VUE_APP_STATIC_NODE_ENV;
  return new TocaWikiLinkShareRangeSet(domId, {
    locale: cloudI18n,
    env: env,
    userInfo: cookie,
    onlyShowAuthDesc: false,
    fileId: fileId,
    isWiki: isWiki,
    canUpdateLinkShareRange: canUpdateUrlAuth,
    shareAuth: '',
    shareScope: '',
    shareExpireDate: null,
    sharePassword: '',
    spaceInfo: {
      spaceId: '0583d',
      spaceName: intl.$t("同程旅行#!!!#src/pages/H5/Cloud/components/share/shareUtil.js_4")
    },
    onUpdateShareRange: onUpdateShareRange,
    onUpdateShareAuthTip: onUpdateShareAuthTip,
    onLinkRangeSetDropdownVisible: onLinkRangeSetDropdownVisible
  });
}